module.exports = __webpack_public_path__ + "img/banner02.ad9f86d8.png";